import { render } from "./Solid.vue?vue&type=template&id=a864ef24"
import script from "./Solid.vue?vue&type=script&lang=js"
export * from "./Solid.vue?vue&type=script&lang=js"

import exportComponent from "D:\\work\\sckj\\tipian\\vue\\tipian_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__